import React from "react";
import { Helmet } from "react-helmet-async";

export default function SEO({ title, description, keywords, canonical }) {
  const siteName = "Hydrotec Solutions";
  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const defaultDesc =
    "Water treatment plants, RO systems, bacteria removal, pump systems, UV disinfection, and chlorination serving Kolkata, Newtown, Rajarhat, and West Bengal.";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDesc} />
      {keywords && <meta name="keywords" content={keywords} />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDesc} />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDesc} />
    </Helmet>
  );
}
